import React, { Component } from 'react';
import ChangePanel from '../../../CreatePanel'

var User = React.createClass({
  handlerDelete: function(){
    io.socket.post("/api/deleteUser", {loginDelete : this.props.user.login, login: this.props.login, pass: this.props.pass}, function (response){
      if(response.success){
        this.setState({confirmation: false});
        this.props.actionReloadUsers(response.users)
      }
    }.bind(this));
  },
  handlerConfirmDelete: function(){
    this.setState({confirm: !this.state.confirm})
  },
  getInitialState: function(){
    return ({
      changePanel: false,
      confirm: false
    })
  },
  handlerChangeOpen: function(){
    this.setState({changePanel: !this.state.changePanel})
  },
  render: function(){
    if(this.state.confirm){
      return(
        <div className="User confirm">
          <div className="question">Вы уверены?</div>
          <div className="true" onClick={this.handlerDelete}>Да</div>
          <div className="false" onClick={this.handlerConfirmDelete}>Нет</div>
        </div>
      )
    }else{
      return(
        <div className="User">
          {this.state.changePanel ? '' : <div className="name">{this.props.user.login}</div>}
          {this.state.changePanel ? '' : <div className="change " onClick={this.handlerChangeOpen}>Изменить</div>}
          {this.state.changePanel ? '' : <div className="remove" onClick={this.handlerConfirmDelete}>Удалить</div>}
          {this.state.changePanel ?
            <ChangePanel
              change={true}
              actionReloadUsers={this.props.actionReloadUsers}
              login={this.props.login}
              pass={this.props.pass}
              user={this.props.user}
              actionChangeOpen={this.handlerChangeOpen}
              specialties={this.props.specialties}
            />
            :
            ''
          }
        </div>
      );
    }
  }
});

export default User;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/AdminPanel/components/UserList/components/User/index.jsx
 **/